import React from "react";
import { Link } from "react-router-dom";

export default function HrSidebar() {
  return (
    <div className="w-64 bg-gray-800 text-white min-h-screen p-6">
      <h2 className="text-2xl font-bold mb-6">HR Portal</h2>
      <nav className="flex flex-col gap-3">
        <Link to="/hr/dashboard" className="hover:bg-gray-700 px-3 py-2 rounded">
          Dashboard
        </Link>
        <Link to="/hr/employees" className="hover:bg-gray-700 px-3 py-2 rounded">
          Employees
        </Link>
        <Link to="/hr/attendance" className="hover:bg-gray-700 px-3 py-2 rounded">
          Attendance
        </Link>
        <Link to="/hr/departments" className="hover:bg-gray-700 px-3 py-2 rounded">
          Departments
        </Link>
        <Link to="/hr/payroll" className="hover:bg-gray-700 px-3 py-2 rounded">
          Payroll
        </Link>
        <Link to="/hr/leaves" className="hover:bg-gray-700 px-3 py-2 rounded">
          Leaves
        </Link>
        <Link to="/hr/reports" className="hover:bg-gray-700 px-3 py-2 rounded">
          Reports
        </Link>
        <Link to="/hr/recruitment" className="hover:bg-gray-700 px-3 py-2 rounded">
          Recruitment
        </Link>
        <Link to="/hr/holidays" className="hover:bg-gray-700 px-3 py-2 rounded">
          Holidays
        </Link>
      </nav>
    </div>
  );
}
